import { ID_MICROINVERSOR } from "src/components/componentes/types";
import { fatorPerdasLimites } from "../constants"

export function validacaoFatorDePerdas(fator_perdas: number, tipoInversor: number): { status: boolean; msg: string } {
  if (!tipoInversor) return { status: true, msg: '' }
  const limites = fatorPerdasLimites[tipoInversor] || null
  if (!limites) return { status: true, msg: ''};
  if (!Number(fator_perdas || 0)) return { status: false, msg: '' } 
  if (Number(fator_perdas) < limites.min) {
    let msg = `O fator de perdas sugerido mínimo é ${limites.min}%, de acordo com as premissas de cálculo.`

    if (tipoInversor === ID_MICROINVERSOR)  {
      msg = `O fator de perdas mínimo para microinversores é ${limites.min}%, de acordo com as premissas de cálculo`
    }

    return { status: false, msg }
  }
  if (Number(fator_perdas) > limites.max) return { status: false, msg: `O fator de perdas não pode ser maior que ${limites.max}%.` } 
  return { status: true, msg : '' }
}